var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"back",staticStyle:{"height":"600px"}},[_c('v-layout',{attrs:{"column":"","fill-height":"","pa-1":""}},[_c('scroll-table',{attrs:{"data":_vm.getTable,"options":_vm.getOptions,"reload":true,"toolbar":"history"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }